import {createRouter, createWebHistory} from 'vue-router'
import Home from "@/components/views/Home.vue";
import Registration from "@/components/views/Registration.vue";
import CallForPages from "@/components/views/CallForPages.vue";
import Program from "@/components/views/Program.vue";
import Speakers from "@/components/views/Speakers.vue";
import Abstract from "@/components/views/Abstract.vue";
import Download from "@/components/views/Download.vue";
import Venue from "@/components/views/Venue.vue";
import Login from "@/components/Login.vue";
import Admin from "@/components/Admin.vue";
import Register from "@/components/Register.vue";
import ForgotPassword from "@/components/ForgotPassword.vue";
import AdminAbstract from "@/components/AdminAbstract.vue";
import AdminPerson from "@/components/AdminPerson.vue";
import AdminLun from "@/components/AdminLun.vue";
import LunImage from "@/components/LunImage.vue";
import Sponsorship from '@/components/views/Sponsorship.vue';
import Sailgene from '@/components/views/Sailgene.vue';
import Sanshubio from '@/components/views/Sanshubio.vue';





const routes = [
    {path: '/', name: 'ICTP2026', component: Home},
    {path: '/registration', name: 'Registration', component: Registration},
    {path: '/call-for-pages', name: 'CallForArticles', component: CallForPages},
    {path: '/program', name: 'Program', component: Program},
    {path: '/speakers', name: 'Speakers', component: Speakers},
    {path: '/abstract', name: 'Abstract', component: Abstract},
    {path: '/venue', name: 'Venue', component: Venue},
    {path: '/download', name: 'Download', component: Download},
    {path: '/login',name:'Login', component: Login},
    {path: '/admin',name:'Admin',component: Admin},
    {path: '/register',name:'Register',component: Register},
    {path: '/forgotPassword',name:'ForgotPassword',component: ForgotPassword},
    {path: '/adminAbstract',name:'AdminAbstract',component: AdminAbstract},
    {path: '/person',name:'Person',component: AdminPerson},
    {path: '/sponsorship',name:'Sponsorship',component: Sponsorship},
    {path: '/sailgene', name: 'Sailgene', component: Sailgene},
    {path: '/sanshubio', name: 'Sanshubio', component: Sanshubio},
    // {path: '/adminLun',name:'AdminLun',component: AdminLun},
    // {path: '/LunImage',name:'Photo',component: LunImage}
];

const router = createRouter({
    BASE_URL:"/conf/",
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
